export default __webpack_public_path__ + "static/contact-form-background-8389d75cc2543359957d9d6ade9f3d89.jpg";